const state = {
  user: null,
  token: '',
  language: "en",
  role: "",
  isAuth: false,
  Usage: 0,
  uiConfig: null,
  systemConfig: null,
  systemType: "earth",
  messages: null,
  msgData: [], //我的消息
  messageSocket: null,
  countSum: null,
  checkTokenTime: 10 * 60000, //10分钟
  upperRouts: null, // 上级路由
  loadding: false,
  msgdata1: {},
  randomNum: 0,
  asyncRoutes: null,
  isEDC: false,
  isPortal: false,
  isBI: false,
};
export default state;
